export const MEASUREMENT_TIMEZONE = 'Europe/Copenhagen';
export function validDailyTimes(times) {
  if (!Array.isArray(times) || times.length < 1 || times.length > 5 || !times.every(t => typeof t === 'string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(t))) return false;
  const minutes = times.map(t => Number(t.slice(0,2))*60+Number(t.slice(3))).sort((a,b)=>a-b);
  // A full session needs time for both sensor commands, also across midnight.
  return minutes.length === 1 || minutes.every((m,i)=>((minutes[(i+1)%minutes.length]-m+1440)%1440)>=5);
}
export function dailyClock(now) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:MEASUREMENT_TIMEZONE,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date(now)).map(p=>[p.type,p.value]));
  return {date:`${parts.year}-${parts.month}-${parts.day}`,time:`${parts.hour}:${parts.minute}`};
}
